<template>
  <div class="label">
    <div class="d-flex justify-space-between" style="font-size: 13px">
        <div>■配送エリア: {{ orderItem.order.location.area.name }}</div>
        <div>■ID: {{ orderItem.id }}</div>
    </div>
    <div class="d-flex">
        <div style="width: 20%">■For: </div>
        <div>{{ orderItem.order.location.name }}</div>
    </div>
    <div class="d-flex">
        <div style="width: 20%">■From: </div>
        <div>{{ orderItem.farm.name }}</div>
    </div>
    <div class="d-flex">
        <div style="width: 30%">■商品名: </div>
        <div>{{ orderItem.flower.flower_specie.name }} ({{ orderItem.flower.flower_genus.name }})</div>
    </div>
    <div class="d-flex" style="font-size: 13px;">
        <div style="width: 20%;">■数量: </div>
        <div>{{ orderItem.count }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    orderItem: Object,
  }
};
</script>

<style scoped>
.label {
  padding: 3mm;
  width: 64mm;
  height: 33.86mm;
  font-size: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
</style>
